/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabel';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel
     */
    value?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel
     */
    tgtAgeLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabel;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabelFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabelFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'tgtAgeLabel': !exists(json, 'tgtAgeLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelFromJSON(json['tgtAgeLabel']),
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabelToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'tgtAgeLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListTgtAgeLabelToJSON(value.tgtAgeLabel),
    };
}

